export type CarrierAccountResourceKey =
  | 'carrier_account.accountFormNameHelper'
  | 'carrier_account.accountFormNameValidate'
  | 'carrier_account.accountFormPeakHelper'
  | 'carrier_account.accountFormFCHelper'
  | 'carrier_account.accountFormFCValidation'
  | 'carrier_account.accountFormTitle'
  | 'carrier_account.accountName'
  | 'carrier_account.carrier'
  | 'carrier_account.carrierValidation'
  | 'carrier_account.peakSurchargeEligible'
  | 'carrier_account.accountFCLabel'
  | 'carrier_account.contactInformation'
  | 'carrier_account.shipperAddress'
  | 'carrier_account.delete_account_warning'
  | 'carrier_account.delete_service_method_warning'
  | 'carrier_account.delete_service_method_param_warning'
  | 'carrier_account.hazmatLimitedQuantityExemptHelper'
  | 'carrier_account.fulfillmentContextsHelper';

export const carrierAccountResources = {
  'carrier_account.hazmatLimitedQuantityExemptHelper':
    'Only check this box if you have negotiated an exemption to hazmat restrictions for this carrier',
  'carrier_account.accountFormNameHelper': 'Enter a name to help you identify this account.',
  'carrier_account.accountFormNameValidate': 'You must provide a name for the account.',
  'carrier_account.accountFormPeakHelper': `Will the carrier's peak surcharges apply to this account?`,
  'carrier_account.accountFormFCHelper': `Which Fulfillment Centers will make use of this carrier account?`,
  'carrier_account.accountFormLabelGenerationHelper': `If this carrier is down, should we use the next best option even if it’s more expensive?`,
  'carrier_account.accountFormFCValidation': 'You must select at least one FC',
  'carrier_account.accountFormTitle': 'Configure Carrier Account',
  'carrier_account.accountName': 'Account Name',
  'carrier_account.carrier': 'Carrier',
  'carrier_account.carrierValidation': 'You must select a carrier',
  'carrier_account.peakSurchargeEligible': 'Peak Surcharge Eligible',
  'carrier_account.peakSurchargeExclusions': 'Peak Surcharge Exclusions',
  'carrier_account.allowLabelGenerationFailover': 'Allow Label Failover (Only set to true if you are sure)',
  'carrier_account.testMode': 'Test Mode',
  'carrier_account.accountFCLabel': 'Account FCs',
  'carrier_account.contactInformation': 'Contact Information',
  'carrier_account.shipperAddress': 'Shipper Address',
  'carrier_account.delete_account_warning':
    'Are you sure you want to delete this account? This action is only reversible by a shipium administrator.',
  'carrier_account.delete_service_method_warning':
    'Are you sure you want to delete this service method? This action is only reversible by a shipium administrator.',
  'carrier_account.delete_service_method_param_warning':
    'Are you sure you want to delete your rates? This action is only reversible by a shipium administrator.',
  'carrier_account.fulfillmentContextsHelper':
    'Fulfillment contexts are optional, but allow you to switch between multiple accounts for the same carrier for the same FC. For more details, see the API documentation for Fulfillment Contexts.',
};
